import { render, staticRenderFns } from "./bulkShipment.vue?vue&type=template&id=969864be&scoped=true&"
import script from "./bulkShipment.vue?vue&type=script&lang=js&"
export * from "./bulkShipment.vue?vue&type=script&lang=js&"
import style0 from "./bulkShipment.vue?vue&type=style&index=0&id=969864be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969864be",
  null
  
)

export default component.exports